module.exports = __webpack_public_path__ + "img/3.f56c593b.png";